import { useEffect, useState } from 'react';

import axiosPixLink from 'config/axiosPixLink';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import SuperConsultantHistoricalBacklinkingsTableControl from 'components/Netlinking/Table/SuperConsultant/SuperConsultantHistoricalBacklinkingsTableControl';
import SuperConsultantSelectedSpotTableControl from 'components/Netlinking/Table/SuperConsultant/SuperConsultantSelectedSpotTableControl';
import { MyCustomHighchartsSmall } from 'components/shared/Charts/MyCustomHighChartsSmall';
import { MyCustomHighcharts } from 'components/shared/Charts/MyCustomHighcharts';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';
import ErrorSuccesModal from 'components/shared/modal/ErrorSuccesModal';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import ExcelUploaderSelection from 'components/shared/UploadExcel/UploadExcelSelection';
import UploadSpotModal from 'components/shared/modal/UploadSpotModal';
import {
  COLOR_JAUGE,
  PIXLINK_CAMPAIGN_STATUS,
  PIXLINK_STATUS,
} from 'utils/Constants';
import { useHistoryState } from 'utils/hooks/useHistoryState';
import {
  calculateClientMinimumLinks,
  calculateMinimumLinks,
} from 'utils/netlinking/linksNumber';
import './order.css';
import { MyCustomReverseHighChats } from 'components/shared/Charts/MyCustomReverseHighChats';
import {
  calculateRefusedClient,
  calculateRefusedPixalione,
  calculateToBeCommanded,
  calculateToBeFilteredConsultant,
  calculateValidateClient,
  calculateValidateSuperAdmin,
  calculateValidateSuperConsultant,
} from 'utils/Jauge/Calculate';
import { calculateSuperConsultantValidateClient } from 'utils/Jauge/CalculateSuperConsultant';
import { Campaign } from '@mui/icons-material';
import FeedbackModal from 'components/shared/modal/FeedBacksModal';
import FeedbackModalShow from 'components/shared/modal/FeedBacksModalShow';
const API = {
  getAvailableThematics: '/netlinking/all-thematics',
  getAvailableLanguages: '/language/all',
  getExistingAccounts: 'website/account/all',
  getAllWriters: '/user/all',
  getAllWebsiteOfAccount: '/website',
  getAllDevisOfAccount: '/user/getDevise',
  updateCampaign: '/campaign/update',
  createSmartOrder: '/commands/addSmartCommand',
  getAllConsultants: '/user/consultants',
  getAllSuperConsultants: 'user/superconsultants',
  getCampaignDetail: '/campaign/campaignDetail/',
};

export default function SuperConsultantCampaignSourcing({ campaignType, campaignStatus, clientNotified, changeNotifyClient,
  handleNetlinkingData,
  handleTmpNetlinkingData }) {
  const dispatch = useDispatch();
  const [urlSearch, setUrlSearch] = useHistoryState('urlSearch', '');
  const { id } = useParams();
  const history = useHistory();
  const { t } = useTranslation();
  const [wantedNetlinkings, setWantedNetlinkings] = useState([]);
  const [historicBackLinkings, setHistoricBackLinkings] = useState([]);
  const [netlinkings, setNetlinkings] = useState([]);
  const [netlinkingsTmp, setNetlinkingsTmp] = useState([]);
  const [nbrOfLinksDemanded, setNbrOfLinksDemanded] = useState(0);
  const [nameSearch, setNameSearch] = useState('');
  const [netlinkingContactFilter, setNetlinkingContactFilter] = useState('');
  const [wantedLinksFocus, setWantedLinksFocus] = useState(false);
  const [wantedLinksList, setWantedLinksList] = useState([]);
  const [wantedLinks, setWantedLinks] = useState('');
  const [modalAddSingleWanted, setModalAddSingleWanted] = useState(false);
  const [ordersPerPage, setOrdersPerPage] = useState(10);
  const [campaignFilter, setCampaignFilter] = useState(null);
  const [netlinkingToExportAddFavorite, setNetlinkingToExportAddFavorite] = useState([]);
  const [isSearchForNetlinkinngOpen, setIsSearchForNetlinkinngOpen] =
    useState(false);

  const [errorSuccess, setErrorSuccess] = useState(false);
  const [errorSuccessMsg, setErrorSuccessMsg] = useState('');
  const [confirmationSaveForce, setConfirmationSaveForce] = useState(false);
  const [confirmationMsgSaveForce, setConfirmationMsgSaveForce] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [active, setActive] = useState(1);
  const [campaignStatusTmp, setCampaignStatusTmp] = useState(campaignStatus);
  const [ancragePlanResult, setAncragePlanResult] = useState(null);
  const navItems = [
    { text: t('Spots sélectionnés'), active: 1 },
    { text: t('Historique Backlinks'), active: 2 },
  ];
  useEffect(() => {
    window.dispatchEvent(new Event('locationchange'));
    document.title = t('PixLink - Detail campaign');
  }, [t]);
  useEffect(() => {
    console.log(campaignStatus);
    console.log(netlinkingToExportAddFavorite.length);
  },);
  useEffect(() => {
    axiosPixLink
      .get(
        API.getCampaignDetail +
        `${window.location.href.split('/')[
        window.location.href.split('/').length - 1
        ]
        }`
      )
      .then((res) => {
        setCampaignFilter(res.data);
        setWantedNetlinkings(res.data.wantedNetlinkings);
        setHistoricBackLinkings(res.data.historicBackLinkings);
        setNetlinkingsTmp(res.data.netlinkingSelecteds);
        handleTmpNetlinkingData(res.data.netlinkingSelecteds)
        setNetlinkings(res.data.netlinkingSelecteds);
        handleNetlinkingData(res.data.netlinkingSelecteds)
        setNbrOfLinksDemanded(res.data.linksNumbers);
      });

  }, []);

  function sendNetlinkingChoose(data) {
    const newData = data.map((item) => {
      if (!item.hasOwnProperty('netlinking')) {
        const newSchemaItem = {
          id: null,
          netlinking: {
            id: item?.id,
            domain: item?.domain,
            kwPositioned: item?.kwPositioned,
            trafic: item?.trafic,
            tF: item?.tF,
            cF: item?.cF,
            tarifHr: item?.tarifHr,
            conditions: item?.conditions,
            themesList: item?.themesList,
            topicsList: item?.topicsList,
            platformName: item?.platformName,
            platformPrice: item?.platformPrice,
            platformRC: item?.platformRC,
            platformHR: item?.platformHR,
            contactPhoneNumber: item?.contactPhoneNumber,
            languageId: item?.languageId,
            contact: item?.contact,
            tarifRc: item?.tarifRc,
            contactedTime: item?.contactedTime,
            type: item?.type
          },
          responsibleRedactio: null,

          responsiblePublication: null,
          programmationDate: null,
          publicationDate: null,
          contactDate: null,
          articleLink: null,
          spotLink: null,
          ancreLink: null,
          insertionLink: null,
          publicationStatus: null,
          redactionStatus: null,
          spotStatus: null,
        };
        return newSchemaItem;
      }

      return item;
    });

    setNetlinkingsTmp(newData);
    handleTmpNetlinkingData(newData)
  }
  const ValiderAncrage = () => {
    axiosPixLink
      .post(`/campaign/validerAncrage/${id}`)
      .then((res) => {
        setIsSuccess(true);
        setErrorSuccessMsg(t("L'ancrage a été validé avec succès !"));
        setErrorSuccess(true);

      })
      .catch((e) => {
        setIsSuccess(false);
        setErrorSuccessMsg(t("Erreur lors de la validation de l'ancrage"));
        setErrorSuccess(true);
      });
  };
  const handleImportAncragePlan = (file) => {
    const formData = new FormData();
    formData.append('file', file);

    axiosPixLink
      .post(`/campaign/${id}/importAncragePlan`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => {
        setAncragePlanResult(res.data);
        if (res.data.notFound && res.data.notFound.length > 0) {
          setIsSuccess(false);
          setErrorSuccessMsg(
            `${res.data.updated} ${t('domaine(s) mis à jour')}.  ${t('Domaines non trouvés')} : ${res.data.notFound.join(', ')}`
          );
        } else {
          setIsSuccess(true);
          setErrorSuccessMsg(`${res.data.updated} ${t('domaine(s) mis à jour avec succès')} !`);
        }
        setErrorSuccess(true);
        axiosPixLink.get(API.getCampaignDetail + id).then((res2) => {
          setNetlinkings(res2.data.netlinkingSelecteds);
          handleNetlinkingData(res2.data.netlinkingSelecteds);
          setNetlinkingsTmp(res2.data.netlinkingSelecteds);
          handleTmpNetlinkingData(res2.data.netlinkingSelecteds);
        });
      })
      .catch((e) => {
        setIsSuccess(false);
        setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
        setErrorSuccess(true);
      });
  };
  const handleWantedLinksChange = (data) => {
    setWantedLinksList(data);
    axiosPixLink
      .post(`/campaign/addWantedNetlinkingFileSelection/${id}`, data)
      .then((res) => {
        const { rejectedDomains } = res.data?.body ?? {};

        if (rejectedDomains && rejectedDomains.length > 0) {
          setIsSuccess(false);
          setErrorSuccessMsg(
            `${rejectedDomains.length} domaine(s) rejeté(s) :\u2028` +
            rejectedDomains.map((d) => `• ${d}`).join('\u2028')
          );
        } else {
          setIsSuccess(true);
          setErrorSuccessMsg(`${t('Spot ajouté au favoris')} !`);
        }
        setErrorSuccess(true);

        axiosPixLink.get(API.getCampaignDetail + id).then((res2) => {
          const data = res2.data;
          setCampaignFilter(data);
          setWantedNetlinkings(data.wantedNetlinkings);
          setHistoricBackLinkings(data.historicBackLinkings);
          setNetlinkingsTmp(data.netlinkingSelecteds);
          handleTmpNetlinkingData(data.netlinkingSelecteds);
          setNetlinkings(data.netlinkingSelecteds);
          handleNetlinkingData(data.netlinkingSelecteds);
          setNbrOfLinksDemanded(data.linksNumbers);
        });
      })
      .catch((e) => {
        setIsSuccess(false);
        switch (e.response.status) {
          case 599:
            setErrorSuccessMsg('Attention le spot ajouté ' + e.response.data + ' semble être dupliqué');
            break;
          case 404:
            setErrorSuccessMsg(`${t("La campagne n'existe plus")}`);
            break;
          default:
            setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
            break;
        }
        setErrorSuccess(true);
      });
  };
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
  const [showFeedbackModalOpen, setShowFeedbackModalOpen] = useState(false);
  const [isSentFeedBackTmp, setIsSentFeedBackTmp] = useState(false);
  const handleFeedbackSubmit = (feedback) => {

    axiosPixLink
      .post(
        `/campaign/validerClientSelectedNetlinking/${id}`,
        feedback)
      .then((res) => {
        setIsSuccess(true);
        setIsSentFeedBackTmp(true);
        setErrorSuccessMsg(
          `${t('Votre Commentaire')} ${t('a été envoyé avec succès')} !`
        );
        const newNetlinkings = netlinkings.map((obj2) => {
          const matches = feedback.filter(
            (f) => f.netlinking.id === obj2.netlinking.id
          );
          if (matches.length === 0) return obj2;

          let feedbacksList = obj2.feedbacksList ?? [];
          let lastFeedbackText = obj2.feedback;

          matches.forEach((obj1) => {
            if (!obj1.feedback) return;
            lastFeedbackText = obj1.feedback;

            if (obj1.feedbackId) {
              // ── update d'un commentaire existant ──
              feedbacksList = feedbacksList.map((fb) =>
                fb.id === obj1.feedbackId
                  ? { ...fb, comment: obj1.feedback, updatedAt: new Date().toISOString() }
                  : fb
              );
            } else {
              // ── nouveau commentaire : on l'ajoute à la liste locale ──
              feedbacksList = [
                ...feedbacksList,
                {
                  id: `tmp-${Date.now()}-${obj2.netlinking.id}`,
                  comment: obj1.feedback,
                  authorRole: 'ROLE_CLIENT',
                  createdAt: new Date().toISOString(),
                },
              ];
            }
          });

          return { ...obj2, feedback: lastFeedbackText, feedbacksList };
        });

        setNetlinkings(newNetlinkings);
        handleNetlinkingData(newNetlinkings);
        setErrorSuccess(true);
        setFeedbackModalOpen(false);
        window.dispatchEvent(
          new CustomEvent('sourcingFeedbackUpdated', { detail: { campaignId: id } })
        );
      })
      .catch((e) => {
        setIsSuccess(false);
        switch (e.response.status) {
          case 404:
            setErrorSuccessMsg(`${t("La campagne n'existe plus")}`);
            break;
          default:
            setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
            break;
        }
        setErrorSuccess(true);
      });
  };
  function openPopupFeedBacks() {
    setFeedbackModalOpen(true)
  }
  function openPopupFeedBackShow() {
    setShowFeedbackModalOpen(true)
  }
  const handleWantedLinksChangeSingle = (data) => {
    setWantedLinksList(data);
    axiosPixLink
      .post(
        `/campaign/addWantedNetlinkingFileSelection/${id}`,
        data
      )
      .then((res) => {
        setIsSuccess(true);
        setErrorSuccessMsg(
          `${t('Spot ajouté au favoris')} !`
        );
        setErrorSuccess(true);
        window.location.reload();
      })
      .catch((e) => {
        setIsSuccess(false);
        switch (e.response.status) {
          case 599:
            setErrorSuccessMsg('Attention le spot ajouté ' + e.response.data + ' semble être dupliqué');
            break;
          case 404:
            setErrorSuccessMsg(`${t("La campagne n'existe plus")}`);
            break;
          default:
            setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
            break;
        }
        setErrorSuccess(true);
      });
  };


  function removeNetlinkingId(items) {
    const updatedNetlinkings = netlinkings.filter(
      (netlinking) =>
        !items.some((item) => item.netlinking.id === netlinking.netlinking.id)
    );
    setNetlinkingsTmp(updatedNetlinkings);
    handleTmpNetlinkingData(updatedNetlinkings)
    setNetlinkings(updatedNetlinkings);
    handleNetlinkingData(updatedNetlinkings)
    RemoveNetlinkingToCampaigns(updatedNetlinkings);
  }
  const sendNewWantedNetlinkingExport = (newWantedNetlinking) => {
    setNetlinkingToExportAddFavorite(newWantedNetlinking)
  };
  const RemoveNetlinkingToCampaigns = (netlinkingswithoutSpot) => {
    axiosPixLink
      .post(
        `/campaign/AddSelectedNetlinking/${id}`,
        netlinkingswithoutSpot.map((object) => ({
          ...object,
          publicationStatus:
            object.publicationStatus === '' ? null : object.publicationStatus,
          redactionStatus:
            object.redactionStatus === '' ? null : object.redactionStatus,
        }))
      )
      .then((res) => {
        setIsSuccess(true);
        setNetlinkings(netlinkingswithoutSpot);
        handleNetlinkingData(netlinkingswithoutSpot)
        setErrorSuccessMsg(
          `${t('Les spots')} ${t('ont été supprimés avec succès')} !`
        );
        setErrorSuccess(true);
      })
      .catch((e) => {
        setIsSuccess(false);
        switch (e.response.status) {
          case 404:
            setErrorSuccessMsg(`${t("La campagne n'existe plus")}`);
            break;
          default:
            setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
            break;
        }
        setErrorSuccess(true);
      });
  };

  const sendUpdateSaveSelectedNetlinking = (updatedData) => {
    setNetlinkingsTmp(updatedData);
    handleTmpNetlinkingData(updatedData)
    setNetlinkings(updatedData);
    handleNetlinkingData(updatedData)
  };

  const SaveNetlinkingToCampaigns = () => {
    setNetlinkings(netlinkingsTmp);
    handleNetlinkingData(netlinkingsTmp)
    axiosPixLink
      .post(
        `/campaign/AddSelectedNetlinking/${id}`,
        netlinkingsTmp.map((object) => ({
          ...object,
          publicationStatus:
            object.publicationStatus === '' ? null : object.publicationStatus,
          redactionStatus:
            object.redactionStatus === '' ? null : object.redactionStatus,
        }))
      )
      .then((res) => {
        setIsSuccess(true);
        setNetlinkings(netlinkingsTmp);
        handleNetlinkingData(netlinkingsTmp)
        setErrorSuccessMsg(
          `${t('Les spots')} ${t('ont été ajoutés avec succes')} !`
        );
        setErrorSuccess(true);
      })
      .catch((e) => {
        setIsSuccess(false);
        switch (e.response.status) {
          case 404:
            setErrorSuccessMsg(`${t("La campagne n'existe plus")}`);
            break;
          default:
            setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
            break;
        }
        setErrorSuccess(true);
      });
  };

  function haveSharedDomain(array1, array2) {
    // Extract domains from array1
    const domains1 = array1.map((obj) => obj?.netlinking?.domain);

    // Iterate over array2 and check if any domain matches
    for (let i = 0; i < array2.length; i++) {
      if (domains1.includes(array2[i]?.domain)) {
        return true; // If match found, return true
      }
    }

    return false; // If no match found, return false
  }

  const GlobalSaveNetlinkingToCampaigns = () => {
    if (haveSharedDomain(netlinkings, historicBackLinkings)) {
      setConfirmationMsgSaveForce(
        'are you sure you want to save while a Backlinking is present'
      );
      setConfirmationSaveForce(true);
    } else {
      SaveNetlinkingToCampaigns();
    }
  };

  const NotifierClientNetlinkingToCampaigns = () => {
    axiosPixLink
      .post(`/campaign/validerSourcingBySuperConsultant/${id}`)
      .then(() => {
        axiosPixLink
          .get(API.getCampaignDetail + id)
          .then((res) => {
            const data = res.data;
            setCampaignFilter(data);
            setWantedNetlinkings(data.wantedNetlinkings);
            setHistoricBackLinkings(data.historicBackLinkings);
            setNetlinkingsTmp(data.netlinkingSelecteds);
            handleTmpNetlinkingData(data.netlinkingSelecteds);
            setNetlinkings(data.netlinkingSelecteds);
            handleNetlinkingData(data.netlinkingSelecteds);
            setNbrOfLinksDemanded(data.linksNumbers);
            setCampaignStatusTmp(data.campaignStatus);
            changeNotifyClient();
            setIsSuccess(true);
            setErrorSuccessMsg(
              `${t('Client')} ${t('a été notifié avec succès')} !`
            );
            setErrorSuccess(true);
          })
          .catch(() => {
            setIsSuccess(false);
            setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
            setErrorSuccess(true);
          });
      })
      .catch((e) => {
        setIsSuccess(false);
        switch (e.response?.status) {
          case 404:
            setErrorSuccessMsg(`${t("La campagne n'existe plus")}`);
            break;
          default:
            setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
            break;
        }
        setErrorSuccess(true);
      });
  };
  return (
    <div>
      <div className="content-center">
        <div className="col-12 col-md-8 mb-2">
          <ul className="nav nav-tabs nav-tabs-ct">
            {navItems.map((item, index) => (
              <li key={index} className="nav-item">
                <button
                  onClick={() => {
                    setActive(item.active);
                  }}
                  className={`nav-link ${item.active === active ? 'active' : ''
                    }`}
                  data-bs-toggle="tab"
                  type="button"
                  role="tab"
                >
                  {item.text}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="row-homePage">
          {active === 1 && (
            <div
              className="col-12 col-md-12 mr-3"
              style={{ marginRight: '5px' }}
            >
              <div className="box-wrapper">
                <div className="box-list-header"></div>
                <SuperConsultantSelectedSpotTableControl
                  netlinkings={netlinkings}
                  campaignFilter={null}
                  wantedNetlinkings={wantedNetlinkings}
                  removeNetlinkingId={removeNetlinkingId}
                  SaveNetlinkingToCampaigns={SaveNetlinkingToCampaigns}
                  sendUpdateSaveSelectedNetlinking={
                    sendUpdateSaveSelectedNetlinking
                  }
                  campaignStatus={campaignStatus}
                  historicBackLinkings={historicBackLinkings}
                  campaignType={campaignType}
                  sendNewWantedNetlinkingExport={sendNewWantedNetlinkingExport}
                ></SuperConsultantSelectedSpotTableControl>

                <div style={{ marginBottom: '25px' }}></div>
              </div>
            </div>
          )}
          {active === 2 && (
            <div
              className="col-12 col-md-12 mr-3"
              style={{ marginRight: '5px' }}
            >
              <div className="box-wrapper">
                <div className="box-list-header"></div>
                <SuperConsultantHistoricalBacklinkingsTableControl
                  historicBackLinkings={historicBackLinkings}
                  campaignFilter={null}
                  wantedNetlinkings={wantedNetlinkings}
                  removeNetlinkingId={removeNetlinkingId}
                  SaveNetlinkingToCampaigns={SaveNetlinkingToCampaigns}
                ></SuperConsultantHistoricalBacklinkingsTableControl>
                <div style={{ marginBottom: '25px' }}></div>
              </div>
            </div>
          )}
        </div>
        {active === 1 && (
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: '10px',
            width: '100%',
          }}>

            {/* LEFT GROUP */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>

              <label
                className="bt-submit-y"
                style={{ cursor: 'pointer', margin: 0 }}
              >
                {t('Importer un plan d\'ancrage')}
                <input
                  type="file"
                  accept=".xls,.xlsx"
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    if (e.target.files && e.target.files[0]) {
                      handleImportAncragePlan(e.target.files[0]);
                      e.target.value = '';
                    }
                  }}
                />
              </label>

              <button
                className="bt-submit-y"
                style={{ margin: 0 }}
                onClick={() => setModalAddSingleWanted(true)}
              >
                {t('Ajouter Spot')}
              </button>

              <div style={{ display: 'flex', alignItems: 'center', marginTop: '-46px' }}>
                <ExcelUploaderSelection
                  handleLinksChange={handleWantedLinksChange}
                  sendFileName={(name) => setWantedLinks(name)}
                  type="wantedLinks"
                />
              </div>
            </div>

            {/* RIGHT GROUP */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>

              {netlinkingToExportAddFavorite.length > 0 ? (
                <button
                  className="bt-submit-y"
                  style={{ margin: 0 }}
                  onClick={openPopupFeedBacks}
                >
                  {t('commentaires')}
                </button>
              ) : (
                <button
                  className="bt-submit-disabled-y"
                  style={{ margin: 0 }}
                  disabled={true}
                >
                  {t('commentaires')}
                </button>
              )}

              {campaignStatus === PIXLINK_CAMPAIGN_STATUS.CAMPAIGN_ANCRAGE_TO_BE_PREPARED && (
                <button
                  className="bt-submit-y"
                  style={{ margin: 0 }}
                  onClick={ValiderAncrage}
                >
                  {t("Valider l'ancrage")}
                </button>
              )}

              <button
                className="bt-submit-y"
                style={{ margin: 0 }}
                onClick={NotifierClientNetlinkingToCampaigns}
              >
                {t('Valider le sourcing')}
              </button>

            </div>
          </div>
        )}
      </div>

      <ErrorSuccesModal
        open={errorSuccess}
        message={errorSuccessMsg}
        handleClose={() => {
          setErrorSuccess(false);
          //       history.goBack();
        }}
        success={isSuccess}
      />
      <ConfirmationModal
        open={confirmationSaveForce}
        message={confirmationMsgSaveForce}
        handleClose={() => setConfirmationSaveForce(false)}
        executeAction={SaveNetlinkingToCampaigns}
      />
      <UploadSpotModal
        open={modalAddSingleWanted}
        handleClose={() => { setModalAddSingleWanted(false) }}
        executeAction={handleWantedLinksChangeSingle}
      />
      <FeedbackModal
        array={netlinkingToExportAddFavorite}
        open={feedbackModalOpen}
        role="ROLE_SUPER_CONSULTANT"
        handleClose={() => setFeedbackModalOpen(false)}
        onSubmit={handleFeedbackSubmit}
      />
      <FeedbackModalShow
        array={netlinkings.filter(item => item.feedback != null && item.feedback != "")}
        open={showFeedbackModalOpen}
        role="ROLE_SUPER_CONSULTANT"
        handleClose={() => setShowFeedbackModalOpen(false)}
        onSubmit={handleFeedbackSubmit}
      />
    </div>
  );
}
